import { useState, useRef, useEffect } from "react";
// import { RiCheckLine } from "react-icons/ri"; // icono de check
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

// Eliminadas interfaces Option y CustomDropdownProps

export const CustomDropdown = ({
    options,
    selected,
    onChange,
    placeholder = "Seleccione...",
    id,
    disabled = false
}) => {
    const [isOpen, setIsOpen] = useState(false);
    // Eliminado el genérico <HTMLDivElement>
    const ref = useRef(null);

    // Cerrar dropdown al hacer click afuera
    useEffect(() => {
        // Eliminados los tipos de event y Node
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (disabled) setIsOpen(false);
    }, [disabled]);

    const handleSelect = (option) => {
        if (disabled) return;
        onChange(option);
        setIsOpen(false);
    };

    return (
        <div className="relative" ref={ref}>
            {/* Área clickeable */}
            <div
                className={`
                    border rounded-lg px-4 py-2 flex justify-between items-center
                    ${disabled
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-300"
                        : "cursor-pointer border-[#097f9f] hover:border-gray-400"}
                `}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{selected ? selected.label : placeholder}</span>
                {!disabled && (
                    <span className="text-[#097f9f]">{isOpen ? "▲" : "▼"}</span>
                )}
            </div>

            {/* Lista de opciones */}
            {!disabled && isOpen && (
                <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                    {options.map((option) => (
                        <li
                            key={option.value}
                            className={`px-4 py-2 cursor-pointer hover:bg-gray-100 flex justify-between items-center ${selected?.value === option.value ? "font-semibold bg-gray-100" : ""
                                }`}
                            onClick={() => handleSelect(option)}
                        >
                            <span>{option.label}</span>
                            {selected?.value === option.value && <FontAwesomeIcon icon={faCheck} className="text-green-700 font-bolder text-xl" />}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};